var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login_loading"},[_c('Loading',{attrs:{"tips":"跳转中，请稍候..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }